module.exports = __webpack_public_path__ + "static/media/furniture.6cced9c3.jpg";